import React from 'react';
import ToolbarMenuItem from 'features/toolbar/ToolbarMenuItem/ToolbarMenuItem';
import { useRestreamingControl } from 'features/toolbar/toolbar/controls/restreaming/useRestreamingControl';
import { ToolbarMenuItemWrapperProps } from 'features/toolbar/types';

const RestreamerControl = ({ onClick }: ToolbarMenuItemWrapperProps) => {
  const { status, icon, label, toggleRestreaming, isFeatureAvailable, badgeColor } =
    useRestreamingControl();

  if (!isFeatureAvailable) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
    toggleRestreaming();
  };

  return (
    <ToolbarMenuItem
      id="restreaming-control"
      overlay={label}
      ariaLabel={label}
      disabled={status === 'starting'}
      badgeActive
      BadgeProps={{
        invisible: status === 'stopped',
        variant: 'dot',
        color: badgeColor,
      }}
      icon={icon}
      onClick={handleClick}
    />
  );
};

export default RestreamerControl;
